
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { IProduct } from '@homeserve/od-typings/api';
import { I18nMixin } from '../../mixins';
import { IProductLinkedProductsDefaultI18n, IProductLinkedProductsOverrideI18n } from './types';

@Component
export default class WLLinkedProducts extends Mixins(I18nMixin) {
  public defaultI18n!: IProductLinkedProductsDefaultI18n;

  public overrideI18n!: IProductLinkedProductsOverrideI18n;
  @Prop()
  private products!: Array<Partial<IProduct>>;

  created() {
    this.defaultI18n = {
      linked_jobs_title: this.$t('components_plugin.product_page.linked_jobs_title'),
    };
  }
}
